<template>
  <el-tabs v-model="editableTabsValue" type="card" closable @tab-remove="onRemoveTab" @tab-click="onClickTab">
    <el-tab-pane
        v-for="item in editableTabs"
        :key="item.name"
        :label="item.title"
        :name="item.name"
    >

    </el-tab-pane>
  </el-tabs>
</template>

<script>
export default {
  name: "Tabs",
  data() {
    return {
      // editableTabsValue: this.$store.state.menus.editableTabsValue,
      // editableTabs: this.$store.state.menus.editableTabs,
    }
  },
  computed: {
    editableTabs: {
      get() {
        return this.$store.state.menus.editableTabs;
      },
      set(val) {
        this.$store.state.menus.editableTabs = val;
      }
    },
    editableTabsValue: {
      get() {
        return this.$store.state.menus.editableTabsValue;
      },
      set(val) {
        this.$store.state.menus.editableTabsValue = val;
      }
    }
  },
  methods: {
    // 新实现：关闭标签
    onRemoveTab(targetName) {
      if (targetName === 'Index') return

      const tabs = this.editableTabs.slice();
      const activeName = this.editableTabsValue;

      let nextActiveName = activeName;
      let nextActivePath = null;
      if (activeName === targetName) {
        const closedIndex = tabs.findIndex(t => t.name === targetName);
        const neighbor = tabs[closedIndex + 1] || tabs[closedIndex - 1] || tabs.find(t => t.name === 'Index');
        if (neighbor) {
          nextActiveName = neighbor.name;
          nextActivePath = neighbor.path || '/index';
        } else {
          nextActiveName = 'Index';
          nextActivePath = '/index';
        }
      }

      // 使用 mutation 移除标签页，确保持久化
      this.$store.commit('removeTabByName', targetName);

      // 设置新的激活标签
      this.$store.commit('setActiveTab', nextActiveName);

      // 推送路由
      if (nextActivePath && this.$route.path !== nextActivePath) {
        this.$router.push(nextActivePath).catch(() => {})
      }

      // 加强兜底：使用 $nextTick 确保状态更新后检查
      this.$nextTick(() => {
        if (this.editableTabs.length === 1 && this.editableTabs[0].name === 'Index') {
          if (this.$route.path !== '/index') {
            this.$router.replace('/index').catch(() => {})
          }
          this.$store.commit('setActiveTab', 'Index');
        }
      });
    },

    // 新实现：点击标签跳转
    onClickTab(target) {
      const tab = this.editableTabs.find(item => item.name === target.name)
      if (!tab) return
      if (tab.path && tab.path !== this.$route.fullPath) {
        this.$router.push(tab.path).catch(() => {})
        return
      }
      if (!tab.path && target.name && target.name !== this.$route.name) {
        this.$router.push({ name: target.name }).catch(() => {})
      }
    }
  }
}
</script>

<style scoped>

</style>